import { oz } from '@weft/utils';
import { created } from '../../utils';

export const MeteredEventSchema = oz.object({
  customerEventId: oz.string(),
  meterId: oz.string(),
  value: oz.number(),
});

export type MeteredEvent = oz.infer<typeof MeteredEventSchema>;

export const CreateMeteredEventSchema = MeteredEventSchema.omit({
  customerEventId: true,
});
export type CreateMeteredEvent = oz.infer<typeof CreateMeteredEventSchema>;

export const DbMeteredEventSchema = created(MeteredEventSchema).openapi('DbMeteredEvent');
export type DbMeteredEvent = oz.infer<typeof DbMeteredEventSchema>;